import React, { useEffect, useMemo, useState } from 'react';
import Page from '../../../components/PageWrapper';
import { Outlet } from 'react-router-dom';

function HirePurchaseOutlet() {

  return (
    <Page title="Hire Purchase">
      <Outlet />
    </Page>
  );
}

export default HirePurchaseOutlet;
